import { LINKEDJSON } from "./constants/specialContentTypes";

const getAllIssues = ({ linkedId, ...rest }) => ({
  method: "GET",
  url: "/issues",
  data: { ...rest, "project.linkedID": linkedId },
});

const submitIssue = (data) => ({
  method: "POST",
  url: "/issues",
  data,
  headers: { ...LINKEDJSON },
});

const editIssue = ({ id, ...data }) => ({
  method: "PUT",
  url: `/issues/${id}`,
  data,
  headers: { ...LINKEDJSON },
});

export const bimIssuesApi = {
  getAllIssues,
  submitIssue,
  editIssue,
};
